import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { showToast } from '../../reusables/CommonFunction';

const AddDentalPaymentForm = ({ show, treatmentPlan, onSave, onCancel }) => {
    const [formData, setFormData] = useState({
        payment_date: "",
        amount: "",
        amount_paid_via: "cash"
    });

    // Reset form when modal opens
    useEffect(() => {
        if (show) {
            setFormData({
                payment_date: "",
                amount: "",
                amount_paid_via: "cash"
            });
        }
    }, [show]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const remBalance = parseFloat(treatmentPlan?.remaining_balance) || 0;
        const enteredAmount = parseFloat(formData.amount) || 0;

        if (!formData.payment_date) {
            showToast("error", "Please select a payment date.");
            return;
        }
        if (enteredAmount <= 0) {
            showToast("error", "Enter a valid amount.");
            return;
        }
        if (enteredAmount > remBalance) {
            showToast("error", `Payment cannot exceed remaining balance of ₹${remBalance.toFixed(2)}.`);
            return;
        }

        const payload = {
            amount: enteredAmount,
            amount_paid_via: formData.amount_paid_via,
            date: formData.payment_date
        };

        if (treatmentPlan?.isBulk) {
            payload.bulk_group = treatmentPlan.bulk_group; // ✅ bulk mode
        } else {
            payload.treatment_id = treatmentPlan.treatment_id; // ✅ single mode
        }

        onSave(payload);
    };

    const remainingBalance = parseFloat(treatmentPlan?.remaining_balance) || 0;

    return (
        <Modal show={show} onHide={onCancel} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {treatmentPlan?.isBulk ? ('Add Payment for Bulk Treatment') : (`Add Payment for Tooth #${treatmentPlan?.tooth_number || ""}`)}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Alert variant="info">
                        Remaining Balance: ₹{remainingBalance.toFixed(2)}
                    </Alert>

                    <Form.Group className='mb-3'>
                        <Form.Label className="required">Payment Date</Form.Label>
                        <Form.Control type="date" name="payment_date" value={formData.payment_date} onChange={handleInputChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="required">Amount</Form.Label>
                        <Form.Control type="number" name="amount" value={formData.amount} onChange={handleInputChange} placeholder="Enter amount" max={remainingBalance} onWheel={(e) => e.target.blur()}/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Payment Method</Form.Label>
                        <Form.Select name="amount_paid_via" value={formData.amount_paid_via} onChange={handleInputChange}>
                            <option value="cash">Cash</option>
                            <option value="card">Card</option>
                            <option value="upi">UPI</option>
                            <option value="other">Other</option>
                        </Form.Select>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel}>Cancel</Button>
                    <Button variant="success" type="submit">Add Payment</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AddDentalPaymentForm;
